import { Component, inject, OnInit, signal, computed } from '@angular/core';
import { HeroSection } from '../../../components/user-dashboard-component/home-page/hero-section/hero-section';
import { Offers } from '../../../components/user-dashboard-component/home-page/offers/offers';
import { IncomingProducts } from '../../../components/user-dashboard-component/home-page/incoming-products/incoming-products';
import { CategoriesSection } from '../../../components/user-dashboard-component/home-page/categories-section/categories-section';
import { NoPharmacies } from '../../../components/user-dashboard-component/pharmacies/no-pharmacies/no-pharmacies';
import { CompaniesSection } from '../../../components/user-dashboard-component/home-page/companies-section/companies-section';
import { PharmacyCreditService } from '../../../services/pharmacy-credit/pharmacy-credit';

@Component({
  selector: 'app-home-page',
  standalone: true,
  imports: [HeroSection, Offers, IncomingProducts, CategoriesSection, CompaniesSection, NoPharmacies],
  templateUrl: './home-page.html',
  styleUrl: './home-page.scss',
})
export class HomePage implements OnInit {
  private pharmacyCreditService = inject(PharmacyCreditService);

  selectedPharmacy = computed(() => this.pharmacyCreditService.selectedPharmacy());
  hasPharmacies = computed(() => this.pharmacyCreditService.hasPharmacies());
  isLoading = computed(() => this.pharmacyCreditService.loadingPharmacies());

  ngOnInit() {
    this.pharmacyCreditService.getMyPharmacies().subscribe((res) => {
      this.pharmacyCreditService.pharmacies.set(res.list);
    });
  }
}
